import React from 'react';
import { Card, Alert, Button } from 'antd';
import { useNavigate } from "react-router-dom";

const UnprocessableEntity = () => {
    const navigate = useNavigate();

    return (
        <Card style={{ maxWidth: 600, margin: "50px auto", textAlign: "center" }}>
            <Alert
                message="422 - Unprocessable Entity"
                description="The request was well-formed but could not be processed."
                type="warning"
                showIcon
            />
            <Button type="primary" style={{ marginTop: 20 }} onClick={() => navigate("/")}>
                Back to Home
            </Button>
        </Card>
    );
};

export default UnprocessableEntity;
